import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Table,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import toastr from "toastr";
import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";
import {
  deleteMatrizEvaluacionPuesto,
  editMatrizEvaluacionPuesto,
  getMatrizEvaluacionPuesto,
  saveMatrizEvaluacionPuesto,
  getModalMatrizEvaluacion,
  cleanModalMatrizEvaluacion,
  getModalMatrizEvaluacionByMatrizId
} from "../../redux/Carrera_Sucesion/MatrizEvaluacionPuesto/actions";
import SidebarDashboard from "../../components/SidebarDashboard";
import { Typeahead } from "react-bootstrap-typeahead";
import { getDescriptorValidation } from "../../redux/descriptorsProfiles/DescriptorValidation/actions";
import { get_tasks_descriptors } from "../../redux/tasks/actions";
import { getTipoCriticidad } from "../../redux/Carrera_Sucesion/TipoCriticidad/actions";
import { getFactoresCriticidad } from "../../redux/Carrera_Sucesion/FactoresCriticidad/actions";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const MatrizEvaluacionPuesto = (props) => {
  const [value, setValue] = useState(null);

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [funSelected, setFunSelected] = useState();
  const [_funcion, setFuncion] = useState(false);
  const [_continue, setContinue] = useState(true);
  const [show, setShow] = useState(false);
  const [resp, setResp] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [erroresEvaluaciones, setErroresEvaluaciones] = useState(null);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [errores, setErrores] = useState([]);
  const [selectedDescriptor, setSelectedDescriptor] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [incorrectValues, setIncorrectValues] = useState(false)
  const dispatch = useDispatch();

  const schema = Yup.object().shape({
    funcion: Yup.string().required("**Campo requerido"),
    nivel: Yup.string().required("**Campo requerido"),

  });

  const {
    loading,
    saveLoading,
    loadingMatrizEvaluacion,
    matrizEvaluacionPuesto,
    matrizEvaluacionPuestoError,
    formError,
    modalMatrizEvaluacion
  } = useSelector((store) => store.matrizEvaluacionPuesto);
  const pages = Math.ceil(
    matrizEvaluacionPuesto ? matrizEvaluacionPuesto.count / limit : 0
  );


  const {
    loading: loadingTipoCriticidad,
    tipoCriticidad,
    tipoCriticidadError,
  } = useSelector((store) => store.tipoCriticidad);

  const { loading: loadingFactores, factoresCriticidad } = useSelector(
    (store) => store.factoresCriticidad
  );

  const tasks = useSelector((store) => store.tasks.tasks);
  const tasksLoader = useSelector((store) => store.tasks.loader);

  const { unidOrg } = useSelector((store) => store.auth);

  const {
    loading: descriptorValidationLoading,
    descriptorExist,
    descriptorComplete,
    menssege,
    descriptor,
  } = useSelector((store) => store.descriptorValidation);

  let funcionOptions = [];
  tasks &&
    // eslint-disable-next-line array-callback-return
    tasks.map((task) => {
      funcionOptions = [
        ...funcionOptions,
        {
          id: task.id,
          label: task.descripcion
            ? `${task.codigo} / ${task.descripcion.toUpperCase()}`
            : "",
          item: task,
        },
      ];
    });

  const history = useHistory();
  const handleResumenClick = (rowData) => {
    history.push({
      pathname: "/sucesion/resumen-evaluacion-de-puesto",
      state: { rowData }
    });
  }


  const columns = [
    {
      Header: "Area",
      accessor: "area",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.descriptor && value.row.original.descriptor[0]?.list_division[0]?.descripcion || ""}
        </div>
      )
    },
    {
      Header: "Función",
      accessor: "funcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.descriptor && value.row.original.descriptor[0]?.list_posicion[0]?.descripcion || ""}
        </div>
      )

    },
    {
      Header: "Negocio",
      accessor: "Negocio",
      Filter: "",
      Cell: (value) => {
        const negocio = value.row.original.info_matriz?.find(item => item.tipo_criticidad === "Negocio");
        return (
          <div>
            {negocio ? negocio.criticidad_promedio.promedio : ""}
          </div>
        );
      }
    },
    {
      Header: "Vulnerabilidad",
      accessor: "vulnerabilidad",
      Filter: "",
      Cell: (value) => {
        const vulnerabilidad = value.row.original.info_matriz?.find(item => item.tipo_criticidad === "Vulnerabilidad");
        return (
          <div>
            {vulnerabilidad ? vulnerabilidad.criticidad_promedio.promedio : ""}
          </div>
        );
      }
    },
    {
      Header: "Nivel criticidad",
      accessor: "criticidad_nombre",
      Filter: "",
      Cell: (value) => (
        <div
          className={`${value.row.original.criticidad_nombre === "Alta Criticidad"
            ? "bg-danger text-light"
            : value.row.original.criticidad_nombre === "Media Criticidad"
              ? "bg-warning text-light"
              : "bg-success text-light"
            } p-2 rounded-pill text-center`}
          style={{
            width: "160px",
          }}
        >
          {/* {value.row.original.estado ? "Abierto" : "Cerrado"} */}
          {value.row.original.criticidad_nombre === "Alta Criticidad"
            ? "Criticidad Alta"
            : value.row.original.criticidad_nombre === "Media Criticidad"
              ? "Criticidad Media"
              : "Criticidad Baja"}
        </div>
      ),
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip>Ver Resumen</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              className="text-dark"
              onClick={() => handleResumenClick(value.row.original)}

            >
              <i className="material-icons">visibility</i>
            </Button>
          </OverlayTrigger>

          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip>Editar</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              type="button"
              onClick={() => onEdit(value.row.original, value.row.index)}
            >
              <i className="material-icons">edit</i>
            </Button>
          </OverlayTrigger>
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip>Eliminar</Tooltip>}
          >
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.matriz_id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  // Métodos
  const _getMatrizEvaluacionPuesto = (
    offs = offset,
    lim = limit,
    filt = filter
  ) =>
    dispatch(
      getMatrizEvaluacionPuesto({
        offset: offs,
        limit: lim,
        tipo_busqueda: "nombre",
        filter: filt,
      })
    );

  const _getModalMatrizEvaluacion = (
    func
  ) =>
    dispatch(
      getModalMatrizEvaluacion({
        funcion: func,
      })
    );


  const _getModalMatrizEvaluacionByMatrizId = (
    idMatriz
  ) =>
    dispatch(
      getModalMatrizEvaluacionByMatrizId({
        tipo_busqueda: "id",
        filter: idMatriz
      })
    );

  const validate = (value) => {
    if (!value || isNaN(value) || value < 1 || value > 5 || !Number.isInteger(Number(value))) {
      return 'Debe ser un número entero entre 1 y 5';
    }
    return null;
  };

  const handleChangeEvaluaciones = (e, groupIndex, factorIndex) => {
    const { value } = e.target;
    const newEvaluaciones = evaluaciones.map((grupo, gi) =>
      gi === groupIndex
        ? grupo.map((factor, fi) =>
          fi === factorIndex ? { ...factor, valor_criticidad: value } : factor
        )
        : grupo
    );


    const newErrores = errores.map((grupoErrores, gi) =>
      gi === groupIndex
        ? grupoErrores.map((error, fi) =>
          fi === factorIndex ? validate(value) : error
        )
        : grupoErrores
    );

    setEvaluaciones(newEvaluaciones);
    setErrores(newErrores);
  };

  const handleSave = () => {
    const saveData = evaluaciones.flatMap((grupo) =>
      grupo.map((evalua) => ({
        factor: evalua.factor,
        valor_criticidad: evalua.valor_criticidad,
      }))
    );
    console.log(saveData)

    let wrongData = saveData.some((item => validate(item.valor_criticidad) !== null ))
    if (wrongData) {
      setIncorrectValues(true)
      return
    }

    let _req = { descriptor: selectedDescriptor, factores: saveData }


    if (!edit) {
      dispatch(saveMatrizEvaluacionPuesto(_req, setShowModal));

    } else {
      dispatch(editMatrizEvaluacionPuesto(_req, editItem.matriz_id, index, setShowModal));
    }
    setFunSelected(null)


  };

  const handleClose = () => {
    setEvaluaciones([]);
    setErrores([]);
    setShowModal(false)
    setEdit(false)
    setFunSelected(null)
    dispatch(cleanModalMatrizEvaluacion())
    setErroresEvaluaciones("")
    setEditItem(null)
    setIncorrectValues(false)
  };

  useEffect(() => {
    _getMatrizEvaluacionPuesto();
    dispatch(
      get_tasks_descriptors(
        {
          unidad_organizativa: unidOrg,
        },
        2
      )
    );
    dispatch(getTipoCriticidad({}));
    dispatch(getFactoresCriticidad({}));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (funSelected && funSelected[0]?.id) {
      _getModalMatrizEvaluacion(funSelected[0].id)
    }
  }, [funSelected])


  useEffect(() => {

    if (edit) {
      _getModalMatrizEvaluacionByMatrizId(editItem.matriz_id)
    }

  }, [editItem])



  useEffect(() => {
    if (modalMatrizEvaluacion) {
      let evaluaciones
      if (edit) {
        evaluaciones = modalMatrizEvaluacion.data[0].info_matriz.map((grupo) =>
          grupo.factores.map((factor) => ({
            factor: factor.factor_id,
            valor_criticidad: factor.valor_criticidad
          }))
        );
        setSelectedDescriptor(modalMatrizEvaluacion.data[0].descriptor[0].id)

      } else {
        evaluaciones = modalMatrizEvaluacion.mensaje[0].info_matriz.map((grupo) =>
          grupo.factores.map((factor) => ({
            factor: factor.factor_responsable_id,
            valor_criticidad: '',
          }))
        );
        setSelectedDescriptor(modalMatrizEvaluacion.mensaje[0].descriptor)

      }

      setEvaluaciones(evaluaciones);
      setErrores(evaluaciones.map(grupo => grupo.map(() => null)));
    }

  }, [modalMatrizEvaluacion])

  const onAdd = () => {
    setValue(null);
    setErrorMessage("");
    setShowModal(true);
    setEdit(false);
    setValidated(false);
    setContinue(true);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);


  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMatrizEvaluacionPuesto(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    if (resp.length !== factoresCriticidad.count) {
      setErrorMessage(messages.factorSelect);
      return;
    }
    const _req = {
      descriptor: descriptor,
      factores: resp,
    };
    if (!edit) {
      // req.anio = anioActual;
      dispatch(saveMatrizEvaluacionPuesto(_req, setShowModal));
    } else {
      dispatch(
        editMatrizEvaluacionPuesto(_req, editItem.matriz_id, index, setShowModal)
      );
    }
    setEdit(false)
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getMatrizEvaluacionPuesto(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteMatrizEvaluacionPuesto(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const ToggleableLink = (props) => {
    const { disabled, ...rest } = props;
    return disabled ? (
      <div
        className="btn btn-light rounded-pill"
        style={{ pointerEvents: "none", opacity: "0.8" }}
        disabled
      >
        {props.children}
      </div>
    ) : (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip style={{ zIndex: 999999999999 }}>
            Descriptores de la función
          </Tooltip>
        }
      >
        <Link
          {...rest}
          className="btn btn-light rounded-pill d-flex flex-wrap justify-content-center align-items-center"
          style={{ textDecoration: "none" }}
          to={`/descriptores-perfiles/seleccion-del-descriptor/${funSelected?.[0]?.id || ""}/${funSelected?.[0]?.item?.descripcion || ""}`}
        // target="_blank"
        >
          {props.children}
        </Link>
      </OverlayTrigger>
    );
  };

  const onShowSidebar = () => setShow(show ? false : true);


  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase d-flex align-items-center">
              <i className="material-icons mr-2">pivot_table_chart</i>Matriz de
              evaluación de puesto
            </h6>
            <Form onSubmit={onSearch}>
              {console.log(modalMatrizEvaluacion?.mensaje?.[0]?.info_matriz?.length === 0 , funSelected)}
              <Row className="justify-content-sm-end align-items-center flex-nowrap">
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip>Ver todos</Tooltip>}
                    >
                      <Button
                        onClick={() => seeAll()}
                        variant="light"
                        size="sm"
                        className="rounded-circle mr-1"
                      >
                        <i className="material-icons">list</i>
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip>Agregar nuevo</Tooltip>}
                    >
                      <Button
                        variant="light"
                        size="sm"
                        className="rounded-circle"
                        onClick={() => onAdd()}
                      >
                        <i className="material-icons">add</i>
                      </Button>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            matrizEvaluacionPuesto &&
            matrizEvaluacionPuesto.count > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={matrizEvaluacionPuesto.data}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={matrizEvaluacionPuesto.count}
                  pages={pages}
                  pagFunc={_getMatrizEvaluacionPuesto}
                />
              </>
            )
          )}
          {(!loading &&
            matrizEvaluacionPuesto &&
            matrizEvaluacionPuesto.count === 0 &&
            matrizEvaluacionPuestoError === "") ||
            (!loading &&
              !matrizEvaluacionPuesto &&
              matrizEvaluacionPuestoError === "") ? (
            <Alert variant="info" className="mt-4 mb-1 mx-3">
              Aún no hay registros, comience agregando algunos
            </Alert>
          ) : null}
          {!loading && !!matrizEvaluacionPuestoError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {matrizEvaluacionPuestoError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={handleClose} size="lg">
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            funcion: edit ? editItem.funcion : "",
            nivel: edit ? editItem.nivel : "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form
              onSubmit={(e) => {
                setIsSubmit(true);
                handleSubmit(e);
              }}
              noValidate
              validated={validated}
            >
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit ? "Editar matriz" : "Crear matriz"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="mt-4 mb-1">
                    {formError}
                  </Alert>
                )}
                {!descriptorExist ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        No existe un descriptor para esta función, ¿Desea
                        agregar uno,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${funSelected?.length > 0 ? funSelected[0].id : ""
                            }/${funSelected?.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                            }`}
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            dispatch(getDescriptorValidation(null));
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!descriptorComplete && funSelected ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>
                        El descriptor para esta función no está completo,{" "}
                        {menssege.toLowerCase()}, ¿Desea completarlo ahora,{" "}
                        <Link
                          to={`/descriptores-perfiles/seleccion-del-descriptor/${funSelected?.length > 0 ? funSelected[0].id : ""
                            }/${funSelected?.length > 0
                              ? funSelected[0].item.descripcion
                              : ""
                            }`}
                        >
                          si
                        </Link>{" "}
                        o{" "}
                        <Link
                          onClick={() => {
                            dispatch(getDescriptorValidation(null));
                          }}
                        >
                          no
                        </Link>
                        ?
                      </p>
                    </Alert>
                  </div>
                ) : null}
                {!_continue ? (
                  <div className="my-1 border-left border-danger">
                    <Alert variant="light">
                      <p>Seleccione otra función para poder continuar.</p>
                    </Alert>
                  </div>
                ) : null}
                <Form.Group as={Col} className="mb-3">
                  <Row className="mt-3 justify-content-center align-items-top flex-nowrap">
                    <Form.Label column sm={3} xs={3}>
                      Función:
                    </Form.Label>
                    <Col sm={9} xs={9}>
                      <Row className="d-flex flex-wrap align-items-center">
                        <Col sm={11} xs={11}>
                          <Typeahead
                            id="funcion"
                            name="funcion"
                            isInvalid={touched.funcion && errors.funcion}
                            isValid={touched.funcion && !errors.funcion}
                            onBlur={handleBlur("funcion")}
                            placeholder="Seleccione una función"
                            options={funcionOptions}
                            onChange={(selected) => {
                              setFieldValue(
                                "funcion",
                                selected.length > 0 ? selected[0].id : ""
                              );
                              setFunSelected(selected);
                              setFuncion(selected.length > 0);
                              dispatch(
                                getDescriptorValidation(selected[0], true, true)
                              );
                            }}
                            selected={funSelected}
                            /*  disabled={
                               tasks.length === 0 ||
                               (edit &&
                                 editItem &&
                                 editItem.list_estado &&
                                 editItem.list_estado.length > 0 &&
                                 editItem.list_estado[0]?.nombre_estado?.toLowerCase() === "cerrado") ||
                               props.match.params.type === "plazas-no-vacantes"
                             } */
                            disabled={edit}
                            defaultInputValue={editItem && editItem.descriptor && editItem.descriptor[0] && editItem.descriptor[0].list_posicion
                              ? `${editItem.descriptor[0].list_posicion[0].codigo}/${editItem.descriptor[0].list_posicion[0].descripcion}`
                              : ""}

                          ></Typeahead>
                        </Col>
                        {tasksLoader || descriptorValidationLoading ? (
                          <Col sm={1} xs={1}>
                            <Spinner animation="border" size="sm" />
                          </Col>
                        ) : (
                          <Col
                            sm={1}
                            xs={1}
                            className="d-flex flex-wrap justify-content-center align-items-center"
                          >
                            <ToggleableLink
                              disabled={
                                !_funcion ||
                                (edit &&
                                  editItem.list_estado &&
                                  editItem.list_estado[0] &&
                                  editItem.list_estado[0].nombre_estado.toLowerCase() === "cerrado") ||
                                props.match.params.type === "plazas-no-vacantes"
                              }
                            >
                              <i className="material-icons">description</i>
                            </ToggleableLink>
                          </Col>
                        )}
                      </Row>
                      {touched.funcion && errors.funcion && (
                        <Col>
                          <small className="text-danger">
                            {errors.funcion}
                          </small>
                        </Col>
                      )}
                      {!tasksLoader && tasks.length === 0 && (
                        <Col>
                          <small className="text-danger">
                            **No se encontraron funciones
                          </small>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </Form.Group>
                {loading || loadingTipoCriticidad || loadingFactores ? (
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                ) : (
                  tipoCriticidad &&
                  tipoCriticidad.count > 0 && (
                    <>
                      {!!errorMessage && (
                        <Alert variant="info" className="mt-4 mb-1">
                          {errorMessage}
                        </Alert>
                      )}


                      <hr />
                      { incorrectValues && (
                        <Alert variant="danger">
                          Verifique que se hayan ingresado todos los valores correctamente.
                        </Alert>
                      )
                        
                      }
                      <div className="table-responsive">
                        <Table striped bordered hover className="table">
                          <thead>
                            <tr>
                              <th>Agrupación</th>
                              <th>Factor</th>
                              <th>Criterio</th>
                              <th>Responsable</th>
                              <th>Evaluación</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modalMatrizEvaluacion && (edit ? modalMatrizEvaluacion.data[0].info_matriz : modalMatrizEvaluacion.mensaje[0].info_matriz).map((grupo, groupIndex) =>
                              grupo.factores.map((factor, factorIndex) => (
                                <tr key={`${groupIndex}-${factorIndex}`}>
                                  <td>{grupo.tipo_criticidad}</td>
                                  <td>{factor.factor_criticidad}</td>
                                  <td>{factor.factor_criterio}</td>
                                  <td>{factor.factor_area}</td>
                                  <td>
                                    <Form.Control
                                      type="number"
                                      min="1"
                                      max="5"
                                      value={
                                        evaluaciones[groupIndex] &&
                                          evaluaciones[groupIndex][factorIndex]
                                          ? evaluaciones[groupIndex][factorIndex].valor_criticidad
                                          : ''
                                      }
                                      onChange={(e) => handleChangeEvaluaciones(e, groupIndex, factorIndex)}
                                    />
                                    {errores[groupIndex] && errores[groupIndex][factorIndex] ? (
                                      <span className="text-danger">
                                        {errores[groupIndex][factorIndex]}
                                      </span>
                                    ) : null}
                                  </td>

                                </tr>

                              ))
                            )}
                            {modalMatrizEvaluacion?.mensaje?.[0]?.info_matriz?.length === 0 ? (
                              <tr>
                                <td colSpan={5}>
                                  <Alert variant="info">
                                    No hay factores criterios aplicables para esta función.
                                  </Alert>
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </Table>
                      </div>
                      <p className="text-danger">
                        {erroresEvaluaciones ? erroresEvaluaciones : null}
                      </p>



                    </>
                  )
                )}

              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Cerrar
                </Button>

                <Button
                  className="rounded-pill"
                  disabled={
                    saveLoading ||
                    loading ||
                    (!edit && !_funcion) ||
                    loadingMatrizEvaluacion ||
                    modalMatrizEvaluacion?.mensaje?.[0]?.info_matriz?.length === 0 ||
                    !funSelected
                  }
                  variant="primary"
                  onClick={handleSave}
                >
                  {saveLoading ||
                    loading ||
                    loadingMatrizEvaluacion ? (
                    <Spinner
                      className="mr-2"
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : null}
                  Guardar
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>

      </Modal>
    </>
  );
};

export default MatrizEvaluacionPuesto;
